module.exports = __webpack_public_path__ + "img/woman_sitting_pc.a0e53052.svg";